<script setup lang="ts">
import { dateSpanishFormatter } from '@/helpers/Date'
import DefaultNotificationComponent from '@/components/notifications/NotificationBarComponents/DefaultNotificationComponent.vue'
import ExportJobFinishedNotificationComponent from '@/components/notifications/NotificationBarComponents/ExportJobFinishedNotificationComponent.vue'
import ImportJobFinishedNotificationComponent from '@/components/notifications/NotificationBarComponents/ImportJobFinishedNotificationComponent.vue'

import { cilTrash, cilCheckCircle } from '@coreui/icons'
import { useNotificationStore } from '@/stores/notificationStore'

const props = defineProps({
  notification: {
    type: Object,
    default: () => {}
  }
})
const notificationsStore = useNotificationStore()

const parsed = JSON.parse(props.notification.data)
function getComponentName(event) {
  switch (event) {
    case 'Import Job Finished':
      return ImportJobFinishedNotificationComponent
    case 'Export Job Finished':
      return ExportJobFinishedNotificationComponent
    default:
      return DefaultNotificationComponent
  }
}
</script>
<template>
  <div class="py-3 border-bottom">
    <div class="row align-middle">
      <div class="col-10">
        <component
          :is="getComponentName(notification.pusher_event)"
          :notification="parsed"
          class="border-success ps-2"
          :style="!notification.checked ? 'border-left: 5px solid' : ''"
        />
      </div>
      <div class="col-2">
        <CButton
          color="success"
          variant="ghost"
          @click="notificationsStore.markNotificationAsRead(notification.id)"
          class="mb-3"
        >
          <CIcon :icon="cilCheckCircle" />
        </CButton>
        <CButton
          color="danger"
          variant="ghost"
          @click="
            async () => {
              await notificationsStore.deleteNotification(notification.id)
            }
          "
        >
          <CIcon :icon="cilTrash" />
        </CButton>
      </div>
    </div>

    <div class="row">
      <div class="col-8">
        <small class="text-muted" style="font-size: 0.75rem">
          {{ dateSpanishFormatter(notification.timestamp * 1000, true) }}
        </small>
      </div>
      <div class="col-4"></div>
    </div>
  </div>
</template>
